// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Menu":"bhe_a bhs_h","Menu__offsetParent":"bhe_b bhs_bj","Menu__trigger--shadowed":"bhe_c"};